import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
      <Typography variant="h4" gutterBottom>
        Privacy Policy
      </Typography>
      <Box mt={2}>
        <Typography variant="body1" paragraph>
          Welcome to GrubSy! Your privacy is important to us, and we are committed to protecting your personal data. This Privacy Policy outlines how we collect, use, and safeguard your information when you use our services.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          - **Personal Information**: Name, email address, phone number, and payment details when you create an account or place an order.
          <br />
          - **Usage Data**: Information about how you use our platform, including pages visited, time spent, and interactions.
          <br />
          - **Device Information**: IP address, browser type, operating system, and device details.
        </Typography>
        <Typography variant="h6" gutterBottom>
          How We Use Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          - To provide and manage your account.
          <br />
          - To process and fulfill your orders.
          <br />
          - To improve our platform and enhance user experience.
          <br />
          - To communicate with you about updates, promotions, and customer support.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Sharing Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          We do not sell or rent your personal data to third parties. However, we may share your information with:
          <br />
          - **Service Providers**: Payment gateways, delivery partners, and IT service providers.
          <br />
          - **Legal Authorities**: If required by law or to protect our legal rights.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Data Security
        </Typography>
        <Typography variant="body1" paragraph>
          We implement robust security measures to protect your data from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Your Rights
        </Typography>
        <Typography variant="body1" paragraph>
          You have the right to:
          <br />
          - Access, update, or delete your personal information.
          <br />
          - Opt-out of promotional communications.
          <br />
          - Request clarification about how your data is used.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Changes to This Policy
        </Typography>
        <Typography variant="body1" paragraph>
          We reserve the right to modify this Privacy Policy at any time, without prior notice or user consent. Any changes will be communicated through our platform or via email. Please review this policy periodically to stay informed.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions or concerns about this Privacy Policy, please contact us at <strong>support@grubsy.com</strong>.
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
